import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { SiteSettings } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useGetSiteSettings() {
	return useQuery<SiteSettings | null>({
		queryKey: ['get-site-settings', schoolId],

		queryFn: async () => {
			const { data, error } = await supabase
				.from('site_settings')
				.select('id, statement_title, statement, primary_color, banner, logo, label_config')
				.eq('school_id', schoolId)
				.maybeSingle();

			if (error) throw error;

			return (data ?? null) as SiteSettings | null;
		},

		staleTime: Infinity,
		refetchOnMount: false,
	});
}
